import { render } from "./createMelk.vue?vue&type=template&id=15131690&scoped=true"
import script from "./createMelk.vue?vue&type=script&lang=js"
export * from "./createMelk.vue?vue&type=script&lang=js"

import "./createMelk.vue?vue&type=style&index=0&id=15131690&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15131690"]])

export default __exports__